import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ManufacturerPrice } from './manufacturer-models';
import { tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { CORE_CONFIG } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class ManufacturerPriceService {

  prices = new BehaviorSubject<ManufacturerPrice[]>([]);

  private _manufacturerBaseURL: string;

  private _priceBaseURL: string;

  constructor(private httpClient: HttpClient,
              @Inject(CORE_CONFIG) private coreConfig: any) {
    this._manufacturerBaseURL = `${this.coreConfig.endpoint}api/v1/manufacturer`;
    this._priceBaseURL = `${this.coreConfig.endpoint}api/v1/manufacturerprice`;
    this.getPrices({ pageSize: 9999 }).subscribe();
  }

  getPrices(params: { [param: string]: any }): Observable<AutoTablePageableResponse<ManufacturerPrice>> {
    if (!params.manufacturerName) {
      return this.httpClient.get<AutoTablePageableResponse<ManufacturerPrice>>(`${this._manufacturerBaseURL}prices`, { params })
        .pipe(tap(rs => this.prices.next(rs.pageItems)));
    } else {
      return this.httpClient.get<AutoTablePageableResponse<ManufacturerPrice>>(
        `${this._manufacturerBaseURL}/${params.manufacturerName}/prices`, { params })
        .pipe(tap(() => this.getPrices({ pageSize: 9999 }).subscribe()));
    }
  }

  newPrice(manufacturerPrice: ManufacturerPrice): Observable<ManufacturerPrice> {
    return this.httpClient.post<ManufacturerPrice>(`${this._priceBaseURL}`, manufacturerPrice);
  }

  updatePrice(manufacturerPrice: ManufacturerPrice): Observable<ManufacturerPrice> {
    return this.httpClient.put<ManufacturerPrice>(`${this._priceBaseURL}/${manufacturerPrice.priceid}`, manufacturerPrice);
  }

  removePrices(priceID: string | string[]): Observable<any> {
    if (_.isArray(priceID)) {
      return this.httpClient.delete(`${this._priceBaseURL}`, {
        params: {
          priceid: priceID
        }
      });
    } else {
      return this.httpClient.delete(`${this._priceBaseURL}/${priceID}`);
    }
  }
}
